

const getSelectedPath = (context) => {
   // const filteredPath = context.path.replace( /\/\d+$/, '' ); // Remove ID from end of path
    return context.path.split( '/' ).pop();
}



export {
    getSelectedPath
}